var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyfigure"},[_c('div',{staticClass:"caption text",domProps:{"innerHTML":_vm._s(_vm.layout.caption)}}),_c('Parallax',{attrs:{"power":0.1}},[_c('img',{attrs:{"src":_vm.layout.image}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }